"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _reduxForm = require("redux-form");
var _CreateApiKeyComponent = _interopRequireDefault(require("./CreateApiKeyComponent"));
var _apiKeyActions = require("../../../redux/actions/apiKeyActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formName = 'createApiKey';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: function changeFieldValue(field, value) {
      dispatch((0, _reduxForm.change)(formName, field, value));
    }
  };
};
var CreateApiKeyContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(_CreateApiKeyComponent["default"]);
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'createApiKey',
  initialValues: {
    trading: false,
    deposit: false,
    withdraw: false,
    IpWhiteList: '',
    accountReadOnly: false
  },
  onSubmit: function onSubmit(payload, dispatch) {
    var updatedPayload = (0, _lodash.omit)(payload, 'restricted', 'IpWhiteListInput');
    if (updatedPayload.deposit || updatedPayload.trading || updatedPayload.withdraw || updatedPayload.accountReadOnly) {
      dispatch((0, _apiKeyActions.createApiKey)(updatedPayload));
    } else {
      throw new _reduxForm.SubmissionError({
        _error: 'Please choose at least one activity'
        //t('Please choose at least one activity')
      });
    }
  }
})(CreateApiKeyContainer);